// PriorRequests — aggregate decision history for a resource: a row of outcome
// dots (newest → oldest) plus the approved/denied tally. Counts only.
// design ref: styles.css:1290 (.dots-row / .d / .d--approved / .d--denied) +
// drawers.jsx AccessRequestResource prior-requests block.

import { Box, Flex, Text } from "@chakra-ui/react";

import type { MFPriorRequests } from "state/members/tasks";

const DOT_BG: Record<"approved" | "denied", string> = {
  approved: "success.500",
  denied: "error.500",
};

export interface PriorRequestsProps {
  data?: MFPriorRequests | null;
}

const PriorRequests = ({ data }: PriorRequestsProps) => {
  if (!data || data.approved + data.denied === 0) {
    return (
      <Text as="span" fontSize="smd" fontWeight={400} color="neutral.600">
        No prior requests yet
      </Text>
    );
  }

  return (
    <Box>
      {/* .dots-row — 4px gap, 10×10 round dots */}
      <Flex gap="2xs" align="center" mb="2xs">
        {data.recent.map((outcome, i) => (
          <Box
            key={i}
            w="10px"
            h="10px"
            borderRadius="full"
            bg={DOT_BG[outcome]}
            title={outcome === "approved" ? "Approved" : "Denied"}
          />
        ))}
      </Flex>
      <Text fontSize="xs" color="neutral.700" fontWeight={400}>
        <Box as="strong" fontWeight={600}>
          {data.approved}
        </Box>{" "}
        approved ·{" "}
        <Box as="strong" fontWeight={600}>
          {data.denied}
        </Box>{" "}
        denied
      </Text>
    </Box>
  );
};

export default PriorRequests;
